/** All autosave copy — provisional pending the design pass. */
export const AUTOSAVE_STRINGS = {
  savedAt: (time: string) => `Saved as you type · ${time}`,
  saving: "Saving…",
  failedRetry: "Couldn't save — retry",
  done: "Done",
  footer: "Edits save as you type. Nothing reaches leasing until you submit.",
  rowConflictHeading: "Couldn't save — this row changed while you were editing",
  rowConflictBody:
    "Nothing you typed has been lost. Try again applies it over the latest version.",
  failedHeading: "Couldn't save",
  failedBody:
    "Your work is still here — it couldn't reach the server. Try again once your connection is back.",
  tryAgain: "Try saving again",
  severityRefusedHeading:
    "Couldn't save that result — this row's options changed",
  severityRefusedBody: (options: string) =>
    `The row now offers ${options}. Your other entries are kept and still save.`,
  nameRefusedHeading: "Couldn't save that name — this row's names changed",
  nameRefusedBody: (options: string) =>
    `The row now offers ${options}. Your other entries are kept and still save.`,
  unloadWarning: "Some edits are still saving.",
};

export const autosaveTimeLabel = (savedAt: number) =>
  new Date(savedAt).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
